import ActionsForm from '@/shared/mixins/actionsForm'
import GroupDetail from '../TemplateDetail/GroupDetail/GroupDetail.vue'
import qmaTemplateMetadataType from '@/shared/http/repositories/business/qmaTemplateMetadataType'
// import qmaTemplate from '@/shared/http/repositories/business/qmaTemplate'
import { toast, loading } from '@/shared/utils/UIHelper'
import ImageNotFound from '../../../../../../../../../static/img/qma/semDados.svg'

export default {
  name: 'equipmentTemplate',
  props: ['templateid'],
  components: {GroupDetail},
  mixins: [ActionsForm],
  data () {
    return {
      equipamento: true,
      notFound: ImageNotFound,
      dadosGrupo: []
    }
  },
  watch: {
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      qmaTemplateMetadataType.GetEquipamentos(this.templateid)
        .then((Response) => {
          loading.pop()
          if (Response.data.length > 0) {
            this.dadosGrupo = Response.data
          } else {
          }
        })
        .catch((Error) => {
          loading.pop()
          toast.error('Dados não encontrados')
        })
    },
    addNovaEtapaIniciar () {
      this.$refs.grupoDetalhes.abrirModalAddEtapa()
    },
    voltaParaGrupo (value) {
      this.$emit('voltaGrupo', value)
    },
    addNovaEtapa (value) {
      this.$emit('addNovaEtapa', value)
    },
    addNovaSubEtapa (value) {
      this.$emit('addNovaSubEtapaObjEtapaNova', value)
    },
    novaEtapaEquipamentoPergunta (value) {
      this.$emit('addNovaPerguntaObjEtapaNova', value)
    },
    addNovaSubEtapaObjSemNovaEtapa (value) {
      this.$emit('addNovaSubEtapaObjSemNovaEtapa', value)
    },
    addNovaPerguntaParaSubEtapa (value) {
      this.$emit('addNovaPerguntaParaSubEtapa', value)
    },
    zeraSubGrupo () {
      this.$refs.grupoDetalhes.voltarParaGrupos()
    },
    abrirPopUpAddEtapa () {
      this.$refs.grupoDetalhes.abrirModalAddEtapa()
    },
    addNovaPerguntaEtapaSubCriada (value) {
      this.$emit('addNovaPerguntaEtapaSubCriada', value)
    },
    ExcluirPerguntaPerguntaEquipamentoCriado (value) {
      this.$emit('ExcluirPerguntaPerguntaEquipamentoCriado', value)
    },
    popUpExcluirEquipamento () {
      this.$refs.grupoDetalhes.popUpExcluirEquipamento()
    },
    ExcluirPerguntaEquipamento (value) {
      this.$emit('ExcluirPerguntaEquipamento', value)
    },
    RemoverEdicaoExcluirPerguntaEquipamento (value) {
      this.$emit('RemoverEdicaoExcluirPerguntaEquipamento', value)
    },
    ExcluirSubEtapasEtapas (value) {
      this.$emit('ExcluirSubEtapasEtapas', value)
    },
    removerExclusaoEtapaSubEtapaEquipamento (value) {
      this.$emit('removerExclusaoEtapaSubEtapaEquipamento', value)
    },
    EditaEquipamentoPergunta (value) {
      this.$emit('EditaEquipamentoPergunta', value)
    },
    EditaEquipamentoNovaPergunta (value) {
      this.$emit('EditaEquipamentoNovaPergunta', value)
    },
    editarEmMemoriaNovaPerguntaEtapaSubCriada (value) {
      this.$emit('editarEmMemoriaNovaPerguntaEtapaSubCriada', value)
    },
    editarEmMemoriaNovaPerguntaParaSubEtapa (value) {
      this.$emit('editarEmMemoriaNovaPerguntaParaSubEtapa', value)
    },
    editarEmMemoriaNovaPerguntaParaEtapa (value) {
      this.$emit('editarEmMemoriaNovaPerguntaParaEtapa', value)
    },
    removerSubEtapaAgEnvioEtapa (value) {
      this.$emit('removerSubEtapaAgEnvioEtapa', value)
    },
    removerSubEtapaEtapaCriada (value) {
      this.$emit('removerSubEtapaEtapaCriada', value)
    },
    editarEtapa (value) {
      this.$emit('editarEtapa', value)
    },
    editaSubEtapa (value) {
      this.$emit('editaSubEtapa', value)
    },
    removerEtapaEquipamentoEstatica (value) {
      this.$emit('removerEtapaEquipamentoEstatica', value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/equipmentTemplate/equipmentTemplate.js